import { buildProps, definePropType } from '@ll-plus/utils'
import type { FormProps } from 'ant-design-vue'
import type { FormColumn } from '@ll-plus/components'
import type { IKeyType, IKeyValueItem } from './key-value'

// 定义 typeRules 常量
export const typeRules: Array<{
  trigger: string[]
  message: string
  validator: (_rule: any, value: any) => Promise<void>
}> = [
  {
    trigger: ['blur', 'change'],
    message: '此字段是必需的',
    validator: async (_rule: any, value: any): Promise<void> => {
      if (!value) {
        return Promise.reject(new Error('此字段是必需的'))
      } else {
        return Promise.resolve()
      }
    }
  }
]

// 定义 formOptions 常量
export const formOptions: FormProps = {
  layout: 'horizontal',
  labelAlign: 'left'
}

// 定义 formColumns 常量
export const formColumns: Array<{
  key: string
  labelCol: {
    span: number
  }
}> = [
  {
    key: 'other',
    labelCol: {
      span: 24
    }
  }
]

// 定义 keyValueItemProps 常量
export const keyValueItemProps = buildProps({
  disabled: {
    type: Boolean,
    default: false
  },
  values: {
    type: definePropType<IKeyValueItem[]>(Array),
    default: (): IKeyValueItem[] => [
      {
        key: null,
        value: null,
        guid: ''
      }
    ]
  },
  disabledValue: {
    type: definePropType<number[]>(Array),
    default: (): number[] => []
  },
  disabledKey: {
    type: definePropType<number[]>(Array),
    default: (): number[] => []
  },
  disabledDelete: {
    type: definePropType<number[]>(Array),
    default: (): number[] => []
  },
  keyValueType: {
    type: definePropType<'single' | 'doubt'>(String),
    default: 'doubt'
  },
  keyType: {
    type: definePropType<FormColumn>(Object),
    default: (): FormColumn => ({
      type: 'input',
      placeholder: '请输入Key'
    })
  },
  keyTypes: {
    type: definePropType<IKeyType[]>(Array),
    default: (): IKeyType[] => []
  },
  valueType: {
    type: definePropType<FormColumn>(Object),
    default: (): FormColumn => ({
      type: 'input',
      placeholder: '请输入Value'
    })
  },
  value: {
    type: definePropType<IKeyValueItem>(Object),
    default: (): IKeyValueItem => ({
      key: '',
      value: '',
      guid: ''
    })
  },
  idx: {
    type: Number,
    required: true
  },
  keyValueTypeDict: {
    type: Object as () => Record<string, string>,
    default: (): Record<string, string> => ({})
  },
  keepLast: {
    type: Boolean,
    default: false
  }
} as const)

// 定义 keyValueItemEmits 常量
export const keyValueItemEmits = {
  delete: (): boolean => true,
  change: (): boolean => true,
  'update:value': (value: IKeyValueItem): boolean => !!value
}
